import colors from 'styles/colors'

const styles = {
  container: {
    display: 'flex',
    paddingLeft: 30
  },
  imageContainer: {
    height: 66,
    width: 49,
    marginRight: 18
  },
  image: {
    boxSizing: 'border-box',
    border: `1px solid ${colors.unicornSilver}`,
    borderRadius: '2px',
    height: '100%',
    objectFit: 'cover'
  },
  providerInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  heading: {
    fontFamily: 'Barlow',
    fontSize: 16,
    fontWeight: 'bold',
    letterSpacing: 0.23,
    lineHeight: '24px',
    color: colors.lightGray
  },
  secondary: {
    fontFamily: 'Barlow',
    fontSize: 12,
    lineHeight: '17px',
    color: colors.grey
  },
  link: {
    fontFamily: 'Barlow',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '17px',
    color: colors.primary,
    cursor: 'pointer'
  }
}

export default styles
